export const FETCH_ROLE_REQUEST = 'FETCH_ROLE_REQUEST';
export const FETCH_ROLE_SUCCEEDED = 'FETCH_ROLE_SUCCEEDED';
export const FETCH_ROLE_FAILED = 'FETCH_ROLE_FAILED';
export const SET_ROLES = 'SET_ROLES';
